'use strict'

/**
 * @classdesc お知らせ作成時に対象のチェック状況に応じて絞り込み条件の
 */
export default class ChangeFilteringConditionsAvailability {
	/**
	 * @param {jQuery} $e - $('.filtering-conditions-availability')
	 */
	constructor($e) {
		console.log(`ChangeFilteringConditionsAvailability.constructor`)
		this._$e = $e
		this._$targetRoot = $(this._$e.data('target-root-selector'))
		this._$e.on('change', () => this.onChange())
		this.onChange()
	}


	onChange() {
		console.log(`ChangeFilteringConditionsAvailability.onChange`)

		if (this._$e.is(':checked')) {
			this._$targetRoot.find('.badge').removeClass('bg-ccc')
			this._$targetRoot.find('button').prop('disabled', false);
			this._$targetRoot
				.find('.selected-categorized-item-count')
				.closest('p')
				.removeClass('c-ccc')
			return
		}

		this._$targetRoot.find('.badge').addClass('bg-ccc')
		this._$targetRoot.find('button').prop('disabled', true);
		this._$targetRoot
			.find('.selected-categorized-item-count')
			.closest('p')
			.addClass('c-ccc')
		return
	}
}
